// require('dotenv').config()

const REACT_APP_URL_API_PRODUCAO_SERVICE = 'https://api.inforcfc.app.br/api/';

const PATH_VERSAO = 'v3';
const PATH_HOMOLOG = PATH_VERSAO + '/homolog';

const PATH_API_NOVA = PATH_VERSAO;

const REACT_APP_URL_API_CAMPANHA_GRAPHQL =
  REACT_APP_URL_API_PRODUCAO_SERVICE + PATH_API_NOVA + '/graphql/';

const URL_CEP_SERVICE = 'https://viacep.com.br/ws/';

export const environment = {
  url_api_producao_service: REACT_APP_URL_API_PRODUCAO_SERVICE,
  url_api_campanha_graphql: REACT_APP_URL_API_CAMPANHA_GRAPHQL,
  url_cep_service: URL_CEP_SERVICE,
  path_api_version: PATH_API_NOVA,
  path_api_homolog: PATH_HOMOLOG,
  api_nova_versao: PATH_VERSAO,
};
